import { cloneDeep } from 'lodash-es'

import {
  FLEXIBLE_NOTE_PII_FIELDS,
  scrubFlexibleNotePII,
} from '@lyrahealth-inc/shared-app-logic/src/features/notes/flexibleNotePII'
import {
  DA_FLEXIBLE_NOTE_REVERSED_CHARGE_EDITABLE_FIELDS,
  getReversedChargeNoteMetadata,
  setFieldsEditable,
  setFieldsReadOnly,
} from '@lyrahealth-inc/shared-app-logic/src/features/notes/reversedChargeNoteMetadata'
import { NoteMetadata } from '@lyrahealth-inc/shared-app-logic/src/models/notes/Notes'

import { DA_FLEXIBLE_NOTE_NAME } from './noteConstants'

export {
  DA_FLEXIBLE_NOTE_REVERSED_CHARGE_EDITABLE_FIELDS,
  FLEXIBLE_NOTE_PII_FIELDS,
  getReversedChargeNoteMetadata,
  scrubFlexibleNotePII,
  setFieldsEditable,
  setFieldsReadOnly,
}

export const DA_SESSION_NOTE_TYPES = ['daSessionNote', 'daInitialNote'] as const

export const isDASessionNoteType = (noteTypeName?: string): boolean =>
  DA_SESSION_NOTE_TYPES.includes(noteTypeName as (typeof DA_SESSION_NOTE_TYPES)[number])

export const getCloseSessionFieldsReadOnlyMetadata = (
  contentMetadata: NoteMetadata,
  fieldNames: string[],
): NoteMetadata => {
  const cloned = cloneDeep(contentMetadata)

  if (cloned.meta_data) {
    setFieldsReadOnly(cloned.meta_data, fieldNames)
  }

  return cloned
}

const REVERSE_CHARGE_ELIGIBLE_NOTE_TYPES: readonly string[] = [...DA_SESSION_NOTE_TYPES, DA_FLEXIBLE_NOTE_NAME]

export const isReverseChargeEligibleNote = (noteName: string | undefined | null): boolean =>
  noteName != null && REVERSE_CHARGE_ELIGIBLE_NOTE_TYPES.includes(noteName)
